import { render, staticRenderFns } from "./SelectSources.vue?vue&type=template&id=b46706fe&"
import script from "./SelectSources.vue?vue&type=script&lang=js&"
export * from "./SelectSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports